import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter, locationShape } from 'react-router';
import { FormattedMessage, defineMessages } from 'react-intl';

import PageTitle from '../../components/PageTitle';
import Grid from '../../components/Grid';
import Header from '../../components/Header';
import List from '../../components/List';
import './styles.css';

import AdvancedSearch from '../AdvancedSearch';

import {
  COMMUNITY_GROUPS_ROUTE_VIEW_PARAM,
  COMMUNITY_INSTITUTIONS_ROUTE_VIEW_PARAM,
  COMMUNITY_PEOPLE_ROUTE_VIEW_PARAM,
} from './constants';

const messages = defineMessages({
  searchResults: {
    id: 'search-results.searchResults',
    defaultMessage: 'Advanced Search',
  },
  people: {
    id: 'search-results.people',
    defaultMessage: 'People',
  },
  institutions: {
    id: 'search-results.institutions',
    defaultMessage: 'institutions',
  },
  groups: {
    id: 'search-results.groups',
    defaultMessage: 'Groups',
  },
});

class SearchResultsPage extends React.PureComponent {
  static propTypes = {
    router: PropTypes.shape({
      params: PropTypes.shape({
        view: PropTypes.string.isRequired,
      }).isRequired,
      push: PropTypes.func.isRequired,
    }).isRequired,
    location: locationShape,
  };

  buildAdvanced = (query) => JSON.parse(query.advanced || '{}');

  render() {
    const { view } = this.props.router.params;
    const { query } = this.props.location;
    const { keyword = '' } = query;
    const advanced = this.buildAdvanced(query);
    const props = { keyword, advanced, view };
    const tabs = [
      COMMUNITY_PEOPLE_ROUTE_VIEW_PARAM,
      COMMUNITY_INSTITUTIONS_ROUTE_VIEW_PARAM,
      COMMUNITY_GROUPS_ROUTE_VIEW_PARAM,
    ];
    const active = {
      groups: view === COMMUNITY_GROUPS_ROUTE_VIEW_PARAM,
      institutions: view === COMMUNITY_INSTITUTIONS_ROUTE_VIEW_PARAM,
      people: view === COMMUNITY_PEOPLE_ROUTE_VIEW_PARAM,
    };

    return (
      <Grid columns={2} stackable id="content">
        <Grid.Row>
          <PageTitle title="Search Result" category="Relationships" />
          <Header id="pageTitle" styleName="searchHeader" as="h1"><FormattedMessage {...messages.searchResults} /> { keyword } </Header>
        </Grid.Row>
        <Grid.Row styleName="listContainer">
          <Grid.Column computer={11} mobile={16} tablet={11} floated="right">
            <List as="nav" link horizontal size="big" styleName="listContainer" role="tablist" aria-label="Search Results Categories">
              {tabs.map((tab, index) => (
                <List.Item key={tab} as="dt" active={active[tab]} styleName="listItem" role="tab" aria-selected={active[tab]}>
                  <div styleName="tab">
                    <Link to={{ pathname: `/search-results/${tab}`, query: { keyword } }} id={`searchResultsTab${tab}`}>
                      <FormattedMessage {...messages[tab]} />
                    </Link>
                  </div>
                </List.Item>
              ))}
            </List>
          </Grid.Column>
        </Grid.Row>
        <AdvancedSearch {...props} />
      </Grid>
    );
  }
}

export default withRouter(SearchResultsPage);
